import React, { useEffect, useState } from 'react';
import {
  Table, TableBody, TableCell, TableHead, TableRow, Button, Box, Typography, Paper,
} from '@mui/material';
import { listClients, deleteClient } from '../utils/api';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';

const ClientList: React.FC = () => {
  const [clients, setClients] = useState<any[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchClients();
  }, []);

  const fetchClients = async () => {
    try {
      const response = await listClients();
      setClients(response.data.data.clients);
    } catch (err) {
      console.error('Failed to fetch clients', err);
    }
  };

  const handleDelete = async (clientId: number) => {
    if (window.confirm('Are you sure you want to delete this client and all associated data?')) {
      try {
        await deleteClient({ client_id: clientId });
        fetchClients();
      } catch (err) {
        console.error('Failed to delete client', err);
      }
    }
  };

  const handleEdit = (client: any) => {
    navigate(`/superadmin/clients/edit/${client.id}`, { state: { client } });
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <Sidebar role="superadmin" />
      <Box sx={{ flexGrow: 1, p: 3, mt: 8 }}>
        <Typography variant="h4" gutterBottom>
          Manage Clients
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate('/superadmin/clients/add')}
          sx={{ mb: 2 }}
        >
          Add Client
        </Button>
        <Paper>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Balance</TableCell>
                <TableCell>Currency</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>GGR %</TableCell>
                <TableCell>API Key</TableCell>
                <TableCell>API Secret</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {clients.map((client) => (
                <TableRow key={client.id}>
                  <TableCell>{client.id}</TableCell>
                  <TableCell>{client.client_name}</TableCell>
                  <TableCell>{client.balance}</TableCell>
                  <TableCell>{client.currency}</TableCell>
                  <TableCell>{client.status}</TableCell>
                  <TableCell>{client.ggr_percentage}</TableCell>
                  <TableCell>{client.api_key}</TableCell>
                  <TableCell>{client.api_secret}</TableCell>
                  <TableCell>
                    <Button onClick={() => handleEdit(client)} sx={{ mr: 1 }}>Edit</Button>
                    <Button onClick={() => handleDelete(client.id)} color="error" sx={{ mr: 1 }}>
                      Delete
                    </Button>
                    <Button onClick={() => navigate(`/superadmin/vendors/${client.id}`)}>
                      Vendors
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      </Box>
    </Box>
  );
};

export default ClientList;